import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth"
import darkLightReducer from "./darkLightTheme"

export const rootReducer = combineReducers({ auth: authReducer, darkLightTheme: darkLightReducer })

